export enum AdminResource {
  users = "users",
  organizations = "organizations",
  results = "results",
}
